module.exports = require("@swa-ui/dotcom/src/DotcomFooter/DotcomDesktopFooter/ColumnList/ColumnList.module.scss");